export const MenuItems = [
    {
        title: "Home",
        url: "/",
        Cname: "nav-links",
        icon: "fa-solid fa-house-user"
    },
    {
        title: "About",
        url: "/about",
        Cname: "nav-links",
        icon: "fa-solid fa-circle-info"
    },
    {
        title: "Service",
        url: "/service",
        Cname: "nav-links",
        icon: "fa-solid fa-briefcase"
    },
    {
        title: "Contact",
        url: "/contact",
        Cname: "nav-links",
        icon: "fa-solid fa-address-book"
    },
    {
        title: "Sign Up",
        url: "/",
        Cname: "nav-links-mobile",
        
    },

]